import { SubpageLayout, RoadmapNote, InfoGrid } from "@/components/site/SubpageLayout";

export default function EWasteRecycling() {
  return (
    <SubpageLayout
      overline="Expanding Capability"
      title="E-Waste"
      accent="Recycling"
      intro="Electronic waste is the fastest-growing waste stream in the world — and one of the richest urban mines. Building on our lead-recycling infrastructure in Bharuch, Metalix XT is extending into responsible e-waste processing: recovering lead, copper and other valuable metals from electronic scrap instead of letting them leak into landfills."
    >
      <InfoGrid
        items={[
          {
            kicker: "What we'll handle",
            title: "Lead-bearing e-scrap",
            body: "Printed circuit boards, CRT glass, UPS and power electronics, and battery-adjacent electronic assemblies containing recoverable lead and solder.",
          },
          {
            kicker: "How we'll do it",
            title: "Compliant processing",
            body: "Dismantling, segregation and metallurgical recovery in line with the E-Waste (Management) Rules — feeding recovered metal straight into our existing refining stream.",
          },
          {
            kicker: "Why it matters",
            title: "Urban mining",
            body: "Every tonne of e-waste processed displaces primary mining. It closes the loop for OEMs and recyclers who need a certified, domestic recovery partner.",
          },
        ]}
      />
      <RoadmapNote />
    </SubpageLayout>
  );
}
